import React from 'react'
import "./Payooner.css"
import "../../index.css"
import { useFormik } from 'formik'

interface InitialValue{
  email:string,
  password:string
}

export const Payooner = () => {
  const formik = useFormik<InitialValue>({
    initialValues:{
      email:'',
      password:''
    },onSubmit:({email,password})=>{
      alert(JSON.stringify({email,password}))
    }
  })
  return (
        <form className='form-payooner'>
            <div className='title'>
                Payoneer <div style={{color:"#0b73c4",marginLeft:'15px',fontSize:'22px'}}> Payment</div>
            </div>
            <input name='email' onChange={formik.handleChange} type="text" className='w-input input-email' placeholder='First and last name'/>
            <input name='password' onChange={formik.handleChange} type="text" className='w-input input-password' placeholder='Address(street, house number)'/>
            <div className='flex-row'>
                <input name='email' onChange={formik.handleChange} type="text" className='w-input input-email' placeholder='City'/>
                <input name='password' onChange={formik.handleChange} type="text" className='w-input input-password' placeholder='Postal code'/>
            </div>
            <div className='flex-row'>
                <input name='email' onChange={formik.handleChange} type="text" className='w-input input-email' placeholder='Country'/>
                <input name='password' onChange={formik.handleChange} type="text" className='w-input input-password' placeholder='Email address'/>
            </div>
            <input name='email' onChange={formik.handleChange} type="text" className='w-input input-email' placeholder='Company name'/>
            <input name='password' onChange={formik.handleChange} type="text" className='w-input input-password' placeholder='Website'/>

            <label className="screen-check">
                <input type="file"/>
                add a payment screen
            </label>
        </form>
  )
}
